import React from 'react';

import { cn } from '@/shared/utils/cn';
import { FileInputProps } from '@/shared/types/CommonTypes';

const FileInput = ({
  label,
  error,
  buttonText = 'Upload',
  isUploading = false,
  selectedFileName,
  placeholder = 'No file selected',
  fullWidth = true,
  className,
  buttonClassName,
  accept,
  onChange,
  name,
  id,
}: FileInputProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  return (
    <div className={cn('text-left', fullWidth && 'w-full')}>
      {label && (
        <label
          htmlFor={id || name}
          className="ml-2 text-[14px] font-semibold leading-[1.4] text-[#444]"
        >
          {label}
        </label>
      )}

      <div
        className={cn(
          'relative mt-1 flex h-10 items-center rounded-full border border-[#ddd] pl-6 pr-28',
          fullWidth && 'w-full',
          error && 'border-red-500',
          className,
        )}
      >
        <input
          readOnly
          value={selectedFileName || ''}
          placeholder={placeholder}
          className={cn(
            'h-full w-full',
            'appearance-none border-0 bg-transparent shadow-none outline-none',
            'px-0 text-[14px] text-[#444] placeholder:text-[#aaa]',
          )}
        />

        <input
          ref={inputRef}
          type="file"
          id={id}
          name={name}
          accept={accept}
          onChange={onChange}
          className="hidden"
        />

        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={isUploading}
          className={cn(
            'absolute right-1 top-1/2 h-8 w-[100px] -translate-y-1/2 cursor-pointer rounded-full border border-[#b995be] bg-transparent text-[14px] font-medium text-[#b995be] hover:border-0 hover:bg-[#b995be] hover:text-white disabled:cursor-not-allowed disabled:opacity-50',
            buttonClassName,
          )}
        >
          {isUploading ? 'Uploading...' : buttonText}
        </button>
      </div>

      {error && <p className="ml-2 mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default FileInput;
